import React from "react";
import { Link } from "react-router-dom";

export function Logo({ size = "md", withTagline = false, invert = false }) {
  const dims = size === "lg" ? "h-11" : size === "sm" ? "h-8" : "h-9";
  const titleSize = size === "lg" ? "text-3xl" : size === "sm" ? "text-lg" : "text-2xl";
  const label = invert ? "text-white" : "text-[#1a3ba8]";
  const orange = "text-[#f57320]";
  const box = invert
    ? "bg-white text-[#1a3ba8]"
    : "bg-gradient-to-br from-[#1a3ba8] via-[#17348f] to-[#0f2260] text-white";
  return (
    <Link to="/" className="inline-flex items-center gap-3 group" data-testid="brand-logo">
      <div className={`${dims} aspect-square rounded-lg ${box} flex items-center justify-center font-display font-bold text-lg tracking-tight shadow-md shadow-[#1a3ba8]/20`}>
        E
      </div>
      <div className="flex flex-col leading-none">
        <span className={`font-display font-bold ${titleSize} tracking-tight`}>
          <span className={label}>EPAY</span>
          <span className={orange}>CASH</span>
        </span>
        {withTagline && (
          <span className={`text-[10px] uppercase tracking-widest mt-1 ${invert ? "text-white/70" : "text-slate-500"}`}>
            Open Your Savings Account Today
          </span>
        )}
      </div>
    </Link>
  );
}

export function StatusBadge({ status }) {
  const map = {
    approved: "bg-emerald-50 text-emerald-700 border-emerald-200",
    etb: "bg-emerald-50 text-emerald-700 border-emerald-200",
    ntb: "bg-sky-50 text-sky-700 border-sky-200",
    pending: "bg-amber-50 text-amber-700 border-amber-200",
    rejected: "bg-rose-50 text-rose-700 border-rose-200",
    duplicate: "bg-rose-50 text-rose-700 border-rose-200",
    not_submitted: "bg-slate-100 text-slate-600 border-slate-200",
  };
  const cls = map[status] || "bg-slate-100 text-slate-600 border-slate-200";
  const label = { not_submitted: "Not Submitted" }[status] || status?.toUpperCase();
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-md border text-[11px] font-medium tracking-wide ${cls}`}>
      {label}
    </span>
  );
}

// Category → color mapping (used for chips, icon backgrounds, etc.)
export function categoryColor(name = "") {
  const n = (name || "").toLowerCase();
  if (n.includes("account") && !n.includes("demat")) return { key: "emerald", grad: "bg-emerald-gradient", chip: "bg-emerald-50 text-emerald-700 border-emerald-200", ring: "ring-emerald-200" };
  if (n.includes("demat")) return { key: "violet", grad: "bg-violet-gradient", chip: "bg-violet-50 text-violet-700 border-violet-200", ring: "ring-violet-200" };
  if (n.includes("credit")) return { key: "orange", grad: "bg-orange-gradient", chip: "bg-orange-50 text-orange-700 border-orange-200", ring: "ring-orange-200" };
  if (n.includes("bc") || n.includes("csp")) return { key: "sky", grad: "bg-sky-gradient", chip: "bg-sky-50 text-sky-700 border-sky-200", ring: "ring-sky-200" };
  if (n.includes("government") || n.includes("govt")) return { key: "rose", grad: "bg-rose-gradient", chip: "bg-rose-50 text-rose-700 border-rose-200", ring: "ring-rose-200" };
  return { key: "slate", grad: "bg-slate-600", chip: "bg-slate-100 text-slate-700 border-slate-200", ring: "ring-slate-200" };
}

export function ServiceLogo({ url, name, size = 44, className = "" }) {
  const [broken, setBroken] = React.useState(false);
  const initials = (name || "?").split(" ").map((s) => s[0]).slice(0, 2).join("").toUpperCase();
  if (url && !broken) {
    return (
      <img
        src={url}
        alt={name || "logo"}
        className={`rounded-lg object-cover bg-white border ${className}`}
        style={{ width: size, height: size }}
        onError={() => setBroken(true)}
      />
    );
  }
  return (
    <div
      className={`rounded-lg flex items-center justify-center font-display font-semibold text-white bg-gradient-to-br from-[#1a3ba8] to-[#2955d8] ${className}`}
      style={{ width: size, height: size, fontSize: size * 0.36 }}
    >
      {initials}
    </div>
  );
}
